(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('DesignEditModeModalCtrl', designEditModeModalCtrl);

    function designEditModeModalCtrl($rootScope, $scope, $mdDialog, designId) {
        $rootScope.saveUpdateAndOptions = 'save-update-options';
        $scope.designId = designId;

        $scope.saveUpdateOptions = function () {
            $mdDialog.hide({ action: $rootScope.saveUpdateAndOptions });
        };

        $scope.save = function () {
            $mdDialog.hide({ action: 'save' });
        };
    }
})();
